import { useSearchPageLoggedOutBrandTileReviewsQuery } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/LoggedOutBrandTileReviews/__internal__/useSearchPageLoggedOutBrandTileReviewsQuery";
export var useSearchPageLoggedOutBrandTileReviews = function() {
    var _result_data;
    var result = useSearchPageLoggedOutBrandTileReviewsQuery();
    return {
        reviews: (_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data.brand_tile_reviews,
        isFetching: result.isFetching
    };
};
